import { CMSResource } from 'app/resources/cmsresource';
export class LoginVMResource extends CMSResource {
	username: string;
	password: string;
	rememberMe?: boolean;
}